import React from 'react';
import * as PropTypes from 'prop-types';
import { Field } from 'redux-form';

export const UserFields = ({ t }) => (
  <React.Fragment>
    <div className="e-field col-6">
      <span className="e-title">{t('name')} *</span>
      <Field name="name" component="input" type="text" required />
    </div>

    <div className="e-field col-6">
      <span className="e-title">{t('email')} *</span>
      <Field name="email" component="input" type="email" required />
    </div>
  </React.Fragment>
);

UserFields.propTypes = {
  t: PropTypes.func.isRequired,
};
